const styles = `:host {
  height: 20px;
  padding: 0 var(--goto-spacing-02);
  font: var(--goto-caption-default-02);
  color: var(--goto-text-01);
  display: inline-flex;
  align-items: center;
  background-color: var(--goto-neutral-03);
  border-radius: 10px;
  white-space: nowrap;
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
}

:host([variant=info]) {
  height: 20px;
  padding: 0 var(--goto-spacing-02);
  font: var(--goto-caption-default-02);
  color: var(--goto-text-info);
  display: inline-flex;
  align-items: center;
  background-color: var(--goto-information-03);
  border-radius: 10px;
  white-space: nowrap;
}

:host([variant=success]) {
  height: 20px;
  padding: 0 var(--goto-spacing-02);
  font: var(--goto-caption-default-02);
  color: var(--goto-text-success-02);
  display: inline-flex;
  align-items: center;
  background-color: var(--goto-success-03);
  border-radius: 10px;
  white-space: nowrap;
}

:host([variant=danger]) {
  height: 20px;
  padding: 0 var(--goto-spacing-02);
  font: var(--goto-caption-default-02);
  color: var(--goto-text-error-02);
  display: inline-flex;
  align-items: center;
  background-color: var(--goto-danger-03);
  border-radius: 10px;
  white-space: nowrap;
}

:host([variant=warning]) {
  height: 20px;
  padding: 0 var(--goto-spacing-02);
  font: var(--goto-caption-default-02);
  color: var(--goto-text-warning-02);
  display: inline-flex;
  align-items: center;
  background-color: var(--goto-warning-03);
  border-radius: 10px;
  white-space: nowrap;
}

:host([counter]) {
  border-radius: 12px;
  font: var(--goto-button-text-small);
  display: inline-grid;
  place-items: center;
  min-height: 20px;
  min-width: 20px;
  padding: 0 6.5px;
  word-break: normal;
  background-color: var(--goto-badge-background-color, var(--goto-danger-01));
  color: var(--goto-badge-color, var(--goto-text-04));
}

:host([counter].dot) {
  padding: 0;
  height: var(--goto-spacing-03);
  width: var(--goto-spacing-03);
  min-height: var(--goto-spacing-03);
  min-width: var(--goto-spacing-03);
}

:host([counter][variant=secondary]) {
  border-radius: 12px;
  font: var(--goto-button-text-small);
  display: inline-grid;
  place-items: center;
  min-height: 20px;
  min-width: 20px;
  padding: 0 6.5px;
  word-break: normal;
  background-color: var(--goto-badge-background-color, var(--goto-neutral-03));
  color: var(--goto-badge-color, var(--goto-text-01));
}`; export default styles;